(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__horizonKlaviyoEmailSignupBound) return;
    window.__horizonKlaviyoEmailSignupBound = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-klaviyo-signup-form]');
      if (!form) return;

      event.preventDefault();

      if (form.dataset.submitting === 'true') return;

      const firstNameInput = form.querySelector('input[name="first_name"]');
      const emailInput = form.querySelector('input[name="email"]');
      const button = form.querySelector('button[type="submit"]');
      const inputGroup = form.querySelector('.klaviyo-signup__controls');
      const message = form.querySelector('.klaviyo-signup__message');
      const messageText = message?.querySelector('.klaviyo-signup__message-text');

      if (!firstNameInput || !emailInput || !button || !message || !messageText) return;

      firstNameInput.setCustomValidity('');
      const firstName = firstNameInput.value.trim();
      const email = emailInput.value.trim();

      if (!firstName) {
        firstNameInput.setCustomValidity('Please enter your first name.');
        firstNameInput.reportValidity();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const publicKey = (form.dataset.klaviyoPublicKey || '').trim();
      const listId = (form.dataset.klaviyoListId || '').trim();
      const customSource = (form.dataset.klaviyoSource || 'Website 10% Off Form').trim();
      const successMessage = form.dataset.successMessage || 'Thanks! Check your inbox for your 10% OFF.';
      const errorMessage = form.dataset.errorMessage || 'Something went wrong. Please try again.';
      const loadingLabel = form.dataset.loadingLabel || 'Submitting...';

      if (!publicKey || !listId) {
        console.error('Klaviyo signup is missing the Public API Key / Site ID or List ID.');
        messageText.textContent = 'Signup is temporarily unavailable. Please try again later.';
        message.hidden = false;
        message.setAttribute('role', 'alert');
        message.focus();
        return;
      }

      const originalButtonHtml = button.innerHTML;
      form.dataset.submitting = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = loadingLabel;
      message.hidden = true;

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: customSource,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  first_name: firstName,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(publicKey)}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/vnd.api+json',
              'Content-Type': 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          let errorBody = '';
          try {
            errorBody = await response.text();
          } catch (readError) {
            errorBody = '';
          }
          console.error('Klaviyo subscription failed:', response.status, errorBody);
          throw new Error(`Klaviyo subscription failed with status ${response.status}`);
        }

        form.reset();
        if (inputGroup) inputGroup.hidden = true;
        messageText.textContent = successMessage;
        message.hidden = false;
        message.setAttribute('role', 'status');
        message.focus();
      } catch (error) {
        console.error(error);
        messageText.textContent = errorMessage;
        message.hidden = false;
        message.setAttribute('role', 'alert');
        message.focus();
      } finally {
        form.dataset.submitting = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = originalButtonHtml;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klayvio-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__horizonKlaviyoEmailSignupBound) return;
    window.__horizonKlaviyoEmailSignupBound = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-klaviyo-signup-form]');
      if (!form) return;

      event.preventDefault();

      if (form.dataset.submitting === 'true') return;

      const firstNameInput = form.querySelector('input[name="first_name"]');
      const emailInput = form.querySelector('input[name="email"]');
      const button = form.querySelector('button[type="submit"]');
      const inputGroup = form.querySelector('.email-signup__input-group');
      const message = form.querySelector('.email-signup__message--klaviyo');
      const messageText = message?.querySelector('.email-signup__message-text');

      if (!firstNameInput || !emailInput || !button || !message || !messageText) return;

      firstNameInput.setCustomValidity('');
      const firstName = firstNameInput.value.trim();
      const email = emailInput.value.trim();

      if (!firstName) {
        firstNameInput.setCustomValidity('Please enter your first name.');
        firstNameInput.reportValidity();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const publicKey = (form.dataset.klaviyoPublicKey || '').trim();
      const listId = (form.dataset.klaviyoListId || '').trim();
      const customSource = (form.dataset.klaviyoSource || 'Website 10% Off Form').trim();
      const successMessage = form.dataset.successMessage || 'Thanks! Check your inbox for your 10% OFF.';
      const errorMessage = form.dataset.errorMessage || 'Something went wrong. Please try again.';
      const loadingLabel = form.dataset.loadingLabel || 'Submitting...';

      if (!publicKey || !listId) {
        console.error('Klaviyo signup is missing the Public API Key / Site ID or List ID.');
        messageText.textContent = 'Signup is temporarily unavailable. Please try again later.';
        message.hidden = false;
        message.setAttribute('role', 'alert');
        message.focus();
        return;
      }

      const originalButtonHtml = button.innerHTML;
      form.dataset.submitting = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = loadingLabel;
      message.hidden = true;

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: customSource,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  first_name: firstName,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(publicKey)}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/vnd.api+json',
              'Content-Type': 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          let errorBody = '';
          try {
            errorBody = await response.text();
          } catch (readError) {
            errorBody = '';
          }
          console.error('Klaviyo subscription failed:', response.status, errorBody);
          throw new Error(`Klaviyo subscription failed with status ${response.status}`);
        }

        form.reset();
        if (inputGroup) inputGroup.hidden = true;
        messageText.textContent = successMessage;
        message.hidden = false;
        message.setAttribute('role', 'status');
        message.focus();
      } catch (error) {
        console.error(error);
        messageText.textContent = errorMessage;
        message.hidden = false;
        message.setAttribute('role', 'alert');
        message.focus();
      } finally {
        form.dataset.submitting = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = originalButtonHtml;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
